//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
  props: ['url'],
  data () {
    return {
      files: [], // 文件缓存
      index: 0 // 序列号
    }
  },
  computed: {
    ...mapState({
      imgStore: state => state.imgstore.img_upload_cache,
      imgPaths: state => state.imgstore.img_paths,
      imgStatus: state => state.imgstore.img_status
    })
  },
  methods: {
    // 选择图片
    selectImgs () {
      let fileList = this.$refs.file.files
      for (let i = 0; i < fileList.length; i++) {
        // 文件过滤
        if (fileList[i].name.match(/.jpg|.gif|.png|.bmp/i)) {
          let item = {
            key: this.index++,
            name: fileList[i].name,
            size: fileList[i].size,
            file: fileList[i]
          }
          // 将图片文件转成BASE64格式
          let reader = new FileReader()
          reader.onload = (e) => {
            this.$set(item, 'src', e.target.result)
          }
          reader.readAsDataURL(fileList[i])
          this.files.push(item)
          this.$store.commit('set_img_upload_cache', this.files) // 存储文件缓存
          this.$store.commit('set_img_status', 'selected') // 更新文件上传状态
        }
      }
    },
    // 上传图片
    submit () {
      let formData = new FormData()
      this.imgStore.forEach((item, index) => {
        item.name = 'imgFiles[' + index + ']'
        formData.append(item.name, item.file)
      })
      formData.forEach((v, k) => console.log(k, ' => ', v))
      // 新建请求
      const xhr = new XMLHttpRequest()
      xhr.open('POST', this.url, true)
      xhr.send(formData)
      xhr.onload = () => {
        if (xhr.status === 200 || xhr.status === 304) {
          let datas = JSON.parse(xhr.responseText)
          console.log('response: ', datas)
          // 存储返回的地址
          let imgUrlPaths = new Set()
          datas.forEach(e => { // error === 0为成功状态
            e.error === 0 && imgUrlPaths.add(e.url)
          })
          this.$store.commit('set_img_paths', imgUrlPaths) // 存储返回的地址
          this.files = [] // 清空文件缓存
          this.index = 0 // 初始化序列号
          this.$store.commit('set_img_status', 'finished') // 更新文件上传状态
        } else {
          alert(`${xhr.status} 请求错误!`)
        }
      }
    },
    // 移除图片
    remove (index) {
      this.files.splice(index, 1)
      this.$store.commit('set_img_upload_cache', this.files) // 更新存储文件缓存
    },
    // 清空图片
    empty () {
      this.files.splice(0, this.files.length)
      this.$store.commit('set_img_upload_cache', this.files) // 更新存储文件缓存
      this.$store.commit('set_img_paths', [])
    }
  },
  beforeCreate () {
    this.$store.commit('set_img_status', 'ready') // 更新文件上传状态
  },
  destroyed () {
    this.$store.commit('set_img_upload_cache', [])
    this.$store.commit('set_img_paths', [])
  },
  watch: {
    imgStatus () {
      if (this.imgStatus === 'uploading') {
        this.submit()
      }
    },
    imgStore () {
      if (this.imgStore.length <= 0) {
        this.$store.commit('set_img_status', 'ready') // 更新文件上传状态
      }
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-easy-uploader/uploader.vue